/** Objeto que contiene información sobre la contratación. Para hiring */

import type { InsuranceProcessStatusEnum, InsuranceStateName } from '@/modules/core/models/enums'

export default class CommonHiringRecovered {
  /** (Integer): Número de la cotización.  */
  quotationNumber!: number

  /** (String): Ciclo de facturación. */
  billingCycle!: string

  /** (Integer): Código del cliente.  */
  clientCode!: number

  /** (Integer): Código del producto asegurado. */
  productCode!: number

  /** (String): Línea de negocio. */
  businessLine!: string

  /** (DateTime): Fecha de inicio del seguro. */
  insuranceStartDate!: string

  /** (String): Precio de la contratación. */
  price!: string

  totalPrice!: string

  insuranceTypes?: number[]

  /** (Integer): Código de paso actual en el proceso de contratación. */
  stepCode!: number

  /** (String): Paso actual en el proceso de contratación. */
  stepDescription!: string

  /** (Integer): Código estado de la contratación. */
  statusCode!: InsuranceProcessStatusEnum

  /** (String): Estado de la contratación. */
  statusDescription!: InsuranceStateName | string

  /** (DateTime): Fecha de expiración de la cotización. */
  expirationDate: string

  /** (String): Correo electrónico para el envío de la cotización. */
  recoveryMail: string | null

  /** (Boolean): Indica si se ha aceptado el consentimiento de privacidad para el envío de la cotización. */
  policyPrivacyConsentRecovery: boolean | null

  /** (String): Correo electrónico para el envío del presupuesto. */
  budgetMail: string | null

  /** (Boolean): Indica si se ha aceptado el consentimiento de privacidad para el envío del presupuesto. */
  policyPrivacyConsentBudget: boolean | null

  /** (String): Tipo de revalorización. */
  revaluationType?: string | null

  constructor(data: any) {
    this.quotationNumber = data.quotationNumber
    this.billingCycle = data.billingCycle
    this.clientCode = data.clientCode
    this.productCode = data.productCode
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.price = data.price
    this.totalPrice = data.totalPrice
    this.insuranceTypes = data.insuranceTypes
    this.stepCode = data.stepCode
    this.stepDescription = data.stepDescription
    this.statusCode = data.statusCode
    this.statusDescription = data.statusDescription
    this.expirationDate = data.expirationDate
    this.recoveryMail = data.recoveryMail
    this.policyPrivacyConsentRecovery = data.policyPrivacyConsentRecovery
    this.budgetMail = data.budgetMail
    this.policyPrivacyConsentBudget = data.policyPrivacyConsentBudget
    this.revaluationType = data.revaluationType
  }
}
